import _DatabaseModel from "./_DatabaseModel";

class Risk extends _DatabaseModel {
  static model = "risk";

  static treatment_kind = [null, "reduce", "accept", "share"];

  static filter = {
    parts: {
      fields: [
        "name",
        "id",
        "owner_id",
        "person_id",
        "risk_level_id",
        "current_risk_level_id",
        "residual_risk_level_id",
      ],
      extended_fields: ["time_filter"],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static tableHeaders = [
    { textKey: "form.label.name", value: "name", sortable: false },
    { textKey: "form.label.owner", value: "owner", sortable: false },
    { textKey: "risk.label.likelihood", value: "likelihood", sortable: false },
    {
      textKey: "risk.label.consequence",
      value: "consequence",
      sortable: false,
    },
    { textKey: "risk.label.risk", value: "risk", sortable: false },
    {
      textKey: "risk.label.current_risk",
      value: "current_risk",
      sortable: false,
    },
    {
      textKey: "risk.label.residual_risk",
      value: "residual_risk",
      sortable: false,
    },
  ];
}

export default Risk;
